<template>
  <div id="error"></div>
</template>
